import Skeleton from 'components/Skeleton';

import useStyles from './styles';

function BrandCarouselSkeleton() {
  const styles = useStyles();

  return (
    <div className={styles.root} data-testid="BrandCarouselSkeleton">
      <div className={styles.slide}>
        <Skeleton />
      </div>
      <div className={styles.content}>
        <Skeleton className={styles.title} />
        <Skeleton className={styles.button} />
      </div>
    </div>
  );
}

export default BrandCarouselSkeleton;
